import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultCustomUnGroupedNameI18nKey } from '../../models/constants.ts';
import { replaceGroupName } from '../../utils/groupsUtilities.ts';
import './EditableGroupTitle.scss';

const EditableGroupTitle = ({
  groupId,
  title,
  setDraftTitle,
  isEditable,
  number,
  handleConfirmRename,
}) => {
  const ref = useRef(null);
  const { t } = useTranslation();

  const handleChange = (e) => {
    setDraftTitle(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleConfirmRename();
  };

  useEffect(() => {
    if (isEditable) {
      ref.current.focus();
    }
  }, [isEditable]);

  return (
    <div role="presentation" className="editable-group-title">
      {number > 0 && (
        <span className="editable-group-title__numbering">{number}. </span>
      )}
      <input
        ref={ref}
        type="text"
        className="editable-group-title__input"
        value={replaceGroupName(
          groupId,
          title,
          t(DefaultCustomUnGroupedNameI18nKey)
        )}
        onChange={handleChange}
        disabled={!isEditable}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default EditableGroupTitle;
